import request from '../../utils/request';
import options from './options';

const urlPath = (url, path) => `${url}${path}`;

export const getCalculatorsYear = filter => request.get({
    url: urlPath(options.apiUrl, filter)
});

export const getCalculatorsYearItem = id => request.get({
    url: urlPath(options.apiUrl, `${id}/`)
});